/**
 * useBenchmark (P168) -- the bank's posture metrics vs the sector
 * baseline. Exec-gated server-side (admin OR approver).
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import type { BenchmarkReport } from "shared/api/types";

export function useBenchmark(): UseQueryResult<BenchmarkReport, ApiError> {
  return useQuery({
    queryKey: ["benchmark"],
    queryFn: () => api.get<BenchmarkReport>("/v1/benchmark"),
  });
}
